import React from 'react';
import PropTypes from 'prop-types';
import { DtpInputMask } from 'dtp-react-components';
import masks from '../../utils/masks';

const InputMask = (props) => {
  const handleChange = (e) => {
    if (props.mask === masks.date && e.target.value === '__/__/____') {
      e.target.value = null;
    }
    props.onChange(e);
  };
  return (
    <DtpInputMask
      {...props}
      className={props.className}
      value={props.value}
      pipe={props.mask === masks.date ? masks.dateCorrect : ''}
      onChange={handleChange}
    />
  );
};

InputMask.defaultProps = {
  className: 'dtp-form-control',
};

InputMask.propTypes = {
  /** Classe css que podera substituir a classe default dtp-form-control */
  className: PropTypes.string,
  mask: PropTypes.isRequired,
  onChange: PropTypes.func.isRequired,
  /** Valor inicial */
  value: PropTypes.string.isRequired,
};

export default InputMask;



// WEBPACK FOOTER //
// ./src/components/ComponentesBasicos/MaskedInput.jsx